import type { PipeTransform } from '@angular/core'
import { Pipe } from '@angular/core'

@Pipe({
  name: 'truncateClean',
  standalone: true,
})
export class TruncateCleanPipe implements PipeTransform {
  transform(value: string | null | undefined, maxLength = 200): string {
    if (!value) return ''

    // Remove HTML tags, entities, and references
    const cleanText = value
      .replace(/<br\s*\/?>/gi, ' ') // Replace <br> tags with spaces
      .replace(/<[^>]+>/g, '') // Remove HTML tags
      .replace(/&[^;]+;/g, '') // Remove HTML entities
      .replace(/\[[^\]]*\]/g, '') // Remove anything between square brackets
      .replace(/,[^A-Za-z]*/g, ', ') // Clean up commas
      .replace(/\s*<[^>]*>/g, '') // Remove anything between angle brackets
      .replace(/\s+/g, ' ') // Replace multiple spaces with single space
      .trim()

    if (cleanText.length <= maxLength) return cleanText

    return cleanText.substring(0, maxLength) + '...'
  }
}
